import { keyBy } from 'lodash';
import { HttpClient } from './http-client';
import { Address } from './Address';
import { Campaign } from './Campaign';
import { AssignedPromotionCode } from './AssignedPromotionCode';
import { NewsletterSubscriptions } from './NewsletterSubscriptions';
import { NewsletterSubscriptionsConfirmation } from './NewsletterSubscriptionsConfirmation';
import { OmsOrderTransactions } from './OmsOrderTransactions';
import { GetNextAvailableDeliveryDate } from './GetNextAvailableDeliveryDate';
import { GetPaazlShippingOptions } from './GetPaazlShippingOptions';
import { ReturnOrder } from './ReturnOrder';
import { SapInventory } from './SapInventory';
import { StoreLocator } from './StoreLocator';
import { SupplierData } from './SupplierData';
import { ForgetMe } from './ForgetMe';
import { DeleteUserRelation } from './DeleteUserRelation';
import { ViewInvoice } from './ViewInvoice';

const traceDetails = process.env.TRACE_DETAILS?.trim() ? keyBy(process.env.TRACE_DETAILS.split(',').map((f) => f.trim()).filter(Boolean)) : undefined;
const publicClient = new HttpClient({
	baseUrl: process.env.NODE_ENV === 'production' && process.env.ITNL_STORE_ENV === 'production' ? '/wcs/resources' : '/api/resources',
	isPublic: true,
	traceDetails,
});
const privateClient = new HttpClient({
	baseUrl: (process.env.USE_MOCK === 'true' ? 'http://localhost:' + process.env.MOCK_HOST_PORT : process.env.TRANSACTION_ORIGIN as string) + '/wcs/resources',
	traceDetails,
});

export const customTransactionsAddress = (pub: boolean) => new Address(pub ? publicClient : privateClient);
export const customTransactionsCampaign = (pub: boolean) => new Campaign(pub ? publicClient : privateClient);
export const customTransactionsAssignedPromotionCode = (pub: boolean) => new AssignedPromotionCode(pub ? publicClient : privateClient);
export const customTransactionsNewsletterSubscriptions = (pub: boolean) => new NewsletterSubscriptions(pub ? publicClient : privateClient);
export const customTransactionsNewsletterSubscriptionsConfirmation = (pub: boolean) => new NewsletterSubscriptionsConfirmation(pub ? publicClient : privateClient);
export const customTransactionsOmsOrderTransactions = (pub: boolean) => new OmsOrderTransactions(pub ? publicClient : privateClient);
export const customTransactionsGetNextAvailableDeliveryDate = (pub: boolean) => new GetNextAvailableDeliveryDate(pub ? publicClient : privateClient);
export const customTransactionsGetPaazlShippingOptions = (pub: boolean) => new GetPaazlShippingOptions(pub ? publicClient : privateClient);
export const customTransactionsReturnOrder = (pub: boolean) => new ReturnOrder(pub ? publicClient : privateClient);
export const customTransactionsSapInventory = (pub: boolean) => new SapInventory(pub ? publicClient : privateClient);
export const customTransactionsStoreLocator = (pub: boolean) => new StoreLocator(pub ? publicClient : privateClient);
export const customTransactionsSupplierData = (pub: boolean) => new SupplierData(pub ? publicClient : privateClient);
export const customTransactionsForgetMe = (pub: boolean) => new ForgetMe(pub ? publicClient : privateClient);
export const customTransactionsDeleteUserRelation = (pub: boolean) => new DeleteUserRelation(pub ? publicClient : privateClient);
export const customTransactionsViewInvoice = (pub: boolean) => new ViewInvoice(pub ? publicClient : privateClient);
